export default __webpack_public_path__ + "static/media/Poland.40a60560.svg";